import React from 'react'
import { RouteComponentProps } from 'react-router'
import SetPassword from '../components/forms/set-password'

interface MatchParams {
  token: string;
}

const Invite: React.FC<RouteComponentProps<MatchParams>> = props => {
  return <SetPassword token={props.match.params.token} title="Benutzer aktivieren" />
}

export default Invite
